export default "__VITE_ASSET__CviV$NXK__"